export default __webpack_public_path__ + "static/media/logo.aa6e57e4.png";